import React, { useState } from 'react';

import IndependentTasks from './IndependentTasks';
import GroupTasks from './GroupTasks';
import IndependentLiveTasks from './IndependentLiveTasks';
import GroupLiveTasks from './GroupLiveTasks';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import { useDispatch } from 'react-redux';
import { setActiveSubTab } from '../../../uiSlice';
import { useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const AccommodationLiveTasks = ({ setisLoading, mainTab }) => {
  const userId = Cookies.get('userId');
  const dispatch = useDispatch();
  const { collapsed } = useSidebar();

  // Get the subTab for the current mainTab from redux
  const activeSubTab = useSelector((state) => state.ui.activeSubTab[mainTab] || 'independent');

  const handleTabChange = (subTab) => {
    dispatch(setActiveSubTab({ mainTab, subTab }));
  };

  return (
    <>
      {/* Tabs - Moved below search box */}
      <div
        className={`fixed top-[7.4rem] z-30 bg-white px-6 py-3 border-t-2   transition-all duration-300 ease-in-out ${
          collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
        }`}>
        <div className="flex gap-8">
          <button
            className={`text-lg font-semibold transition-colors duration-200 ${
              activeSubTab === 'independent'
                ? 'text-[#2A565E]'
                : 'text-gray-400 hover:text-gray-600'
            }`}
            onClick={() => handleTabChange('independent')}>
            Independent
          </button>
          <button
            className={`text-lg font-semibold transition-colors duration-200 ${
              activeSubTab === 'group' ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
            }`}
            onClick={() => handleTabChange('group')}>
            Group
          </button>
        </div>
        <div className="mt-1">
          <div
            className="h-[2px] bg-[#2A565E] transition-all duration-300"
            style={{
              width: activeSubTab === 'independent' ? '105px' : '52px',
              transform: `translateX(${activeSubTab === 'independent' ? '0' : '135px'})`
            }}
          />
        </div>
      </div>
      {activeSubTab === 'independent' ? (
        <IndependentLiveTasks setisLoading={setisLoading} />
      ) : (
        <GroupLiveTasks setisLoading={setisLoading} />
      )}
    </>
  );
};

export default AccommodationLiveTasks;
